export default "/settings/change-password"
